import { z } from 'zod'

export const TrackingProductsSchema = z.object({
  ProdutoID: z.string(),
  Produto: z.string().min(3),
  Instituicao: z.string().optional(),
  Valor: z.number().min(0).positive(),
  Desconto: z.number(),
  Tipo: z
    .enum(['Gratuito', 'Assinatura', 'Combo', 'Curso', 'Módulo'])
    .optional(),
  Carreira: z.string().min(3),
  Cargo: z.string().optional(),
  Formacao: z.string().min(3).optional(),
  Edital: z.string().min(3).optional(),
})

export const TrackingPaymentSchema = z.object({
  Pagamento: z.enum(['Cartão de Crédito', 'Boleto', 'Pix', 'Gratuito']),
  Parcelas: z.number().min(1).positive(),
})

export const TrackingConfirmationSchema = z.object({
  Status: z.enum(['Confirmado', 'Pendente', 'Recusado']),
  Pedido: z.number().min(1).positive().optional(),
})

export const TrackingCheckoutSchema = z
  .object({
    Produtos: z.array(TrackingProductsSchema).optional(),
    Total: z.number().min(0),
    Cupom: z.string().optional(),
    Desconto: z
      .enum(['Cupom', 'Padrão', 'Link', 'Campanha', 'Nenhum'])
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.Produtos?.some((p) => TrackingProductsSchema.safeParse(p))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['Produtos'],
        message: 'Deve haver ao menos um produto no carrinho',
      })
    }
  })
